import { render } from "./HomeContact.vue?vue&type=template&id=44a20f80&scoped=true&ts=true&lang=pug"
import script from "./HomeContact.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeContact.vue?vue&type=script&lang=ts&setup=true"

import "./HomeContact.vue?vue&type=style&index=0&id=44a20f80&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a20f80"]])

export default __exports__